// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Navigationitem_navLink__3O9nJ"};